module.exports = __webpack_public_path__ + "img/summary-dispute-rejected.c20d5d8f.svg";